/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionQuotasNotifications } from './SubscriptionQuotasNotifications';
import {
    SubscriptionQuotasNotificationsFromJSON,
    SubscriptionQuotasNotificationsFromJSONTyped,
    SubscriptionQuotasNotificationsToJSON,
    SubscriptionQuotasNotificationsToJSONTyped,
} from './SubscriptionQuotasNotifications';
import type { SubscriptionQuotasConsumers } from './SubscriptionQuotasConsumers';
import {
    SubscriptionQuotasConsumersFromJSON,
    SubscriptionQuotasConsumersFromJSONTyped,
    SubscriptionQuotasConsumersToJSON,
    SubscriptionQuotasConsumersToJSONTyped,
} from './SubscriptionQuotasConsumers';

/**
 * Quotas for the subscription. These quotas are used to limit the number of consumers and notifications for this subscription.
 * @export
 * @interface SubscriptionQuotas
 */
export interface SubscriptionQuotas {
    /**
     * 
     * @type {SubscriptionQuotasConsumers}
     * @memberof SubscriptionQuotas
     */
    consumers?: SubscriptionQuotasConsumers;
    /**
     * 
     * @type {SubscriptionQuotasNotifications}
     * @memberof SubscriptionQuotas
     */
    notifications?: SubscriptionQuotasNotifications;
}

/**
 * Check if a given object implements the SubscriptionQuotas interface.
 */
export function instanceOfSubscriptionQuotas(value: object): value is SubscriptionQuotas {
    return true;
}

export function SubscriptionQuotasFromJSON(json: any): SubscriptionQuotas {
    return SubscriptionQuotasFromJSONTyped(json, false);
}

export function SubscriptionQuotasFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionQuotas {
    if (json == null) {
        return json;
    }
    return {
        
        'consumers': json['consumers'] == null ? undefined : SubscriptionQuotasConsumersFromJSON(json['consumers']),
        'notifications': json['notifications'] == null ? undefined : SubscriptionQuotasNotificationsFromJSON(json['notifications']),
    };
}

export function SubscriptionQuotasToJSON(json: any): SubscriptionQuotas {
    return SubscriptionQuotasToJSONTyped(json, false);
}

export function SubscriptionQuotasToJSONTyped(value?: SubscriptionQuotas | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consumers': SubscriptionQuotasConsumersToJSON(value['consumers']),
        'notifications': SubscriptionQuotasNotificationsToJSON(value['notifications']),
    };
}

